import { useMutation } from 'react-query';

import { exportFromOpcXerFile as mutationFn } from 'api/endPoints/exportFromOpcXerFile';

export const useMutationExportFromOpcXerFile = () => {
    return useMutation<any, QueryError, any>((params) => mutationFn(params));
};
